import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { isFollowingTags, followTag, unfollowTag } from 'actions/follow'
import { loadTaggedPosts } from 'actions/posts'
import log from 'lib/log'
import clsx from "clsx"

import HomeNewsTagPage from '../HomeNewsTagPage'
import Card from 'components/Card'
import BigButton from 'components/BigButton'
import TaggedPostsList from './TaggedPostsList'
import styles from './HomeNewsTagPostsPage.css'

const Unfollow = ({ tag, onUnfollowTag }) => {
  return (
    <div className={styles.unfollow}>
      <FormattedMessage id="tags.home_following" />
      <BigButton label="tags.following" onClick={onUnfollowTag} />
    </div>
  )
}

const Follow = ({ tag, onFollowTag }) => {
  return (
    <div className={styles.follow}>
      <FormattedMessage id="tags.home_unfollowing" />
      <BigButton label="tags.follow" onClick={onFollowTag} />
    </div>
  )
}

const FollowOrUnfollowTag = ({ tag, isFollowing, onFollow, onUnfollow }) => {
  return (
    <Card>
      <div className={styles.follow_or_unfollow}>
        {isFollowing ? (
          <Unfollow tag={tag} onUnfollowTag={onUnfollow} />
        ) : (
          <Follow tag={tag} onFollowTag={onFollow} />
        )}
      </div>
    </Card>
  )
}

class HomeNewsTagPostsPage extends Component {
  constructor(props) {
    super(props)
    this._onFollowTag = this._onFollowTag.bind(this)
    this._onUnfollowTag = this._onUnfollowTag.bind(this)
  }
  async _onFollowTag() {
    const {
      profile,
      tag,
      onFollowTag,
      doLoadTaggedPosts,
      doIsFollowingTags
    } = this.props
    await onFollowTag(tag)
    try {
      await doLoadTaggedPosts({ tag })
    } catch (e) {
      log.error(e)
    }
  }
  async _onUnfollowTag() {
    const {
      profile,
      tag,
      onUnfollowTag,
      doLoadTaggedPosts,
      doIsFollowingTags
    } = this.props
    await onUnfollowTag(tag)
    try {
      await doIsFollowingTags({
        entities: [tag],
        followerId: profile._id
      })
      await doLoadTaggedPosts({ tag })
    } catch (postsErr) {
      log.error(postsErr)
    }
  }
  render() {
    const { profile, tag, isFollowingTag } = this.props
    return (
      <HomeNewsTagPage>
        <div className={clsx("ns", styles.tag_screen_content)}>
          {profile ? (
            <FollowOrUnfollowTag
              tag={tag}
              isFollowing={isFollowingTag}
              onFollow={this._onFollowTag}
              onUnfollow={this._onUnfollowTag}
            />
          ) : null}
          <TaggedPostsList />
        </div>
      </HomeNewsTagPage>
    )
  }
}

const mapStateToProps = ({
  location: { payload: { tag } },
  session: { value: profile },
  following: { tags: { map } = {} } = {}
}) => {
  let isFollowingTag = map && map[tag]
  return {
    profile,
    tag,
    isFollowingTag
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch: dispatch,
  onFollowTag: bindActionCreators(followTag, dispatch),
  onUnfollowTag: bindActionCreators(unfollowTag, dispatch),
  doLoadTaggedPosts: bindActionCreators(loadTaggedPosts, dispatch),
  doIsFollowingTags: bindActionCreators(isFollowingTags, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(
  HomeNewsTagPostsPage
)
